import { useState, useEffect } from "react";

function getTimeLeft(targetDate) {
  const now = new Date().getTime();
  const distance = targetDate - now;

  if (distance <= 0) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0, launched: true };
  }

  return {
    days: Math.floor(distance / (1000 * 60 * 60 * 24)),
    hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
    minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
    seconds: Math.floor((distance % (1000 * 60)) / 1000),
    launched: false,
  };
}

// April 22, 2026 12:00 PM MYT (UTC+8) = 04:00 UTC
const LAUNCH_DATE = new Date("2026-04-22T04:00:00Z").getTime();

export default function CountdownTimer({ className = "" }) {
  const [timeLeft, setTimeLeft] = useState(() => getTimeLeft(LAUNCH_DATE));

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(getTimeLeft(LAUNCH_DATE));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  if (timeLeft.launched) {
    return (
      <div className={`text-center ${className}`} data-testid="countdown-timer">
        <p className="text-[#FF007F] font-bold text-lg tracking-wide" style={{ fontFamily: "Outfit, sans-serif" }}>
          WE ARE LIVE!
        </p>
      </div>
    );
  }

  const units = [
    { label: "DAYS", value: timeLeft.days },
    { label: "HRS", value: timeLeft.hours },
    { label: "MIN", value: timeLeft.minutes },
    { label: "SEC", value: timeLeft.seconds },
  ];

  return (
    <div className={`flex items-center justify-center gap-3 sm:gap-4 ${className}`} data-testid="countdown-timer">
      {units.map((unit, i) => (
        <div key={unit.label} className="flex items-center gap-3 sm:gap-4">
          <div className="flex flex-col items-center">
            <span
              className="text-2xl sm:text-3xl font-black text-white tabular-nums"
              style={{ fontFamily: "JetBrains Mono, monospace", minWidth: "2ch", textAlign: "center" }}
            >
              {String(unit.value).padStart(2, "0")}
            </span>
            <span className="text-[10px] sm:text-xs text-[#71717A] tracking-widest mt-1">
              {unit.label}
            </span>
          </div>
          {i < units.length - 1 && (
            <span className="text-[#FF007F] text-xl font-bold -mt-4">:</span>
          )}
        </div>
      ))}
    </div>
  );
}
